import { useRouter } from "next/router"
import posthog from "posthog-js"
import { PostHogProvider as PHProvider } from "posthog-js/react"
import type { ReactNode } from "react"
import { useEffect } from "react"

if (typeof window !== "undefined" && process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: false, // 手動でページビューをトラッキング
    capture_pageleave: true, // ページ離脱を自動トラッキング
    capture_performance: false, // Web Vitalsのパフォーマンス測定を無効化
    autocapture: {
      dom_event_allowlist: ["click"], // クリックイベントのみ自動キャプチャ
      css_selector_allowlist: ["[data-track]"], // data-track属性のある要素のみ
    },
    debug: process.env.NODE_ENV === "development", // 開発環境でデバッグモード有効
    loaded: (posthog) => {
      // PostHogが読み込まれたらコンソールに表示
      if (process.env.NODE_ENV === "development") {
        console.log("🚀 PostHog loaded successfully!")
        console.log("PostHog ID:", posthog.get_distinct_id())
      }
    },
  })

  // 環境情報を全イベントに追加
  posthog.register({
    environment: process.env.NODE_ENV,
  })
}

export function PostHogPageview(): null {
  const router = useRouter()

  useEffect(() => {
    // ページビューをトラッキング
    const handleRouteChange = () => posthog?.capture("$pageview")

    router.events.on("routeChangeComplete", handleRouteChange)

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange)
    }
  }, [router.events])

  return null
}

interface PostHogProviderProps {
  children: ReactNode
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  return <PHProvider client={posthog}>{children}</PHProvider>
}
